module.exports = __webpack_public_path__ + "static/warforged-builders-ac4ff8979e3f46d16330fe6ab37e4483.png";